import {
  listen,
  getRouterValue,
  getSectionTop,
  getSectionsHistoryTop,
  onRouterValueChanged,
} from 'weblite-router'
import throttle from 'lodash.throttle'
import { NATIVE_COLORS_VALUE_NAME } from './hooks'
import {
  setNativeThemeColorImmediately,
  setBottomSafeAreaColorImmediately,
} from '$func/native-colors'
import { isDesktopSize } from '$func/environmentInfo.js'

function updateNativeColors() {
  if (isDesktopSize()) return

  const activeSection = getSectionsHistoryTop()
  // if (!activeSection || activeSection === 'overlay') return
  if (!activeSection) return

  const activePanel = getSectionTop(activeSection)
  if (!activePanel || activePanel === 'INIT') return

  const activeNativeColors = getRouterValue(
    NATIVE_COLORS_VALUE_NAME,
    activePanel,
  )

  setNativeThemeColorImmediately(activeNativeColors?.statusBar || 'default')
  setBottomSafeAreaColorImmediately(
    activeNativeColors?.bottomSafeArea || 'default',
  )
}

const throttledUpdateNativeColors = throttle(updateNativeColors, 150)

listen(throttledUpdateNativeColors)
onRouterValueChanged(NATIVE_COLORS_VALUE_NAME, throttledUpdateNativeColors)
